import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  signContractsRequest,
  signContractRequest,
  fetchUnsignedContractsActions,
  fetchPendingContractsActions,
  selectAccountId,
  selectUnsignedContracts,
  selectPendingContracts,
  selectToken,
} from '../../../auth/ducks';
import { showModal } from '../../../modal/ducks';
import { apiCallIds as loanApiCallIds } from '../../../loans/api';
import { getFileUrl } from '../../../../common/utils/helpers';
import { contractTypeT, contractType, loanActions, loanActionsT } from '../../../../common/enums';
import SignBLock from './SignBlock';
import { selectIsInProgress } from '../../../spinner/ducks';
import { apiCallIds } from '../../../auth/api';
import { t } from '../../../../app/i18n/index';
import { Row } from 'antd/lib/index';
import Button from 'antd/lib/button';
import SignLoanContractBlock from '../../../loans/components/SignLoanContractBlock';

const baseWeb = process.env.REACT_APP_WEB_URL

const applicationSigningContractTypes = [
    contractType.GENERAL,
    contractType.MANDATE,
    contractType.INSURANCE_APPLICATION,
];

const isApplicationSigningContract = contract =>
    applicationSigningContractTypes.indexOf(contract.type) > -1;

const mapStateToProps = state => ({
  accountId: selectAccountId(state),
  token: selectToken(state),
  unsignedContracts: selectUnsignedContracts(state),
  pendingContracts: selectPendingContracts(state),
  isLoading: selectIsInProgress(state, apiCallIds.SIGN_CONTRACT),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
        signContract: signContractRequest,
        signContracts: signContractsRequest,
        fetchUnsignedContracts: fetchUnsignedContractsActions.request,
        fetchPendingContracts: fetchPendingContractsActions.request,
        showConfirmLoanModal: loanId => showModal({ id: loanApiCallIds.CONFIRM_LOAN, data: loanId }),
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
@translate()
export default class SignContractDebtor extends Component {
    state = {
        signedContracts: {},
    }

    static propTypes = {
        isLoading: PropTypes.bool.isRequired,
        actions: PropTypes.object.isRequired,
        accountId: PropTypes.string.isRequired,
        token: PropTypes.string.isRequired,
        contract: PropTypes.object,
        t: PropTypes.func.isRequired,
        pendingLoan: PropTypes.object,
    };

    componentDidMount() {
        const { actions, accountId } = this.props;
        actions.fetchUnsignedContracts({ accountId });
        actions.fetchPendingContracts({ accountId });
    }

    onSubmitAll = e => {
        const { actions, accountId, unsignedContracts, pendingLoan } = this.props;
        let contracts = unsignedContracts
            .filter(isApplicationSigningContract)
            .map(contract => contract.id);

        if (contracts.length === 0 && pendingLoan && pendingLoan.action === loanActions.ENTER_SMS_CODE_CONTRACT) {
            actions.showConfirmLoanModal(pendingLoan.id);
            return;
        }

        actions.signContracts({ accountId, contracts, pendingLoanId: pendingLoan ? pendingLoan.id : null });
    };

    onConfirmPendingLoan = () => {
        const { actions, pendingLoan } = this.props;
        if (pendingLoan) {
            actions.showConfirmLoanModal(pendingLoan.id);
        }
    };

    getFileLocation(contract) {
        const { token } = this.props;
        return contract ? getFileUrl(contract.fileId, token) : undefined;
    }

    onChecked = (contractType, val) => {
        this.setState((prevState) => {
            let signedContracts = prevState.signedContracts;

            return {
                signedContracts: {
                    ...signedContracts,
                    [contractType]: val
                }
            }
        })
    }

    renderBlocks(contracts, options = {}) {
        const boxStyle = {
            borderRadius: '10px',
            borderStyle: 'solid',
            padding: '20px',
            marginBottom: '20px',
            borderWidth: '1px',
        }

        //console.log(unsignedContracts);
        return contracts
            .filter(isApplicationSigningContract)
            .map(contract => {
            const fileLocation = this.getFileLocation(contract);
            if (!fileLocation) return null;

            let blockContent = null;

            switch (contract.type) {
                case contractType.GENERAL:
                    blockContent = this.renderGeneralContract(contract);
                    break;
                case contractType.MANDATE:
                    blockContent = this.renderLoanApplicationContract(contract)
                    break;
                case contractType.INSURANCE_APPLICATION:
                    blockContent = this.renderInsuranceApplicationContract(contract)
                    break;
                case contractType.DEDUCTIONS_AGREEMENT:
                    blockContent = this.renderDeductionsAgreementContract(contract)
                    break;
                default:
                    return null;
            }

            if (blockContent && options.forceChecked) {
                blockContent = React.cloneElement(blockContent, {
                    isChecked: true,
                    isDisabled: true,
                    onChecked: () => {},
                });
            }

            if (blockContent) {
                return <div style={boxStyle} key={contract.id}>
                    {blockContent}
                </div>
            }
        })
    }

    renderPendingSmsConfirmation() {
        const { isLoading, pendingContracts, t } = this.props;

        return (
            <div>
                {this.renderBlocks(pendingContracts, { forceChecked: true })}
                <p>{t('SMS kód bol odoslaný. Pre dokončenie podpisu zadajte SMS kód.')}</p>
                <Row>
                    <div className='ant-modal-footer'>
                        <Button
                            size="small"
                            type="primary"
                            loading={isLoading}
                            onClick={this.onConfirmPendingLoan}
                        >
                            {loanActionsT[loanActions.ENTER_SMS_CODE_CONTRACT]}
                        </Button>
                    </div>
                </Row>
            </div>
        );
    }

    renderLoanApplicationContract(mandateContract) {
        const { isLoading, t } = this.props;
        const fileLocation = this.getFileLocation(mandateContract);

        if (!fileLocation) return null;

        let modalText = t(
            'Dlžník sa oboznámil so znením Záväznej žiadosti o pôžičku (zmluva medzi Vami a prevádzkovateľom portálu Majak.sk, spoločnosť Peer2Peer, s.r.o.), rozumie jej, súhlasí s jej znením a berie na vedomie všetky jej účinky ako aj všetky práva a povinnosti z nej vyplývajúce. Je si vedomý, že kliknutím na tlačidlo “Potvrdiť Záväznú žiadosť o pôžičku” je táto zmluva pre dlžníka v celom svojom rozsahu záväzná.'
        )
        let checkBoxText = t('Súhlasím so Záväznou žiadosťou o pôžičku')
        let buttonText = t('Potvrdiť Záväznú žiadosť o pôžičku')

        return (
            <SignBLock
                isLoading={isLoading}
                fileLocation={fileLocation}
                insuranceFileLocation={null}
                title={contractTypeT.MANDATE_DEBTOR}
                text={modalText}
                checkboxText={checkBoxText}
                buttonText={buttonText}
                fileLinktext={t('Prečítať Záväznú žiadosť o pôžičku')}
                onChecked={(val) => this.onChecked(contractType.MANDATE, val)}
                isChecked={this.state.signedContracts.MANDATE == true}
            />
        );
    }

    renderInsuranceApplicationContract(insuranceContract) {
        const { isLoading, t } = this.props;

        const insuranceFileLocation = this.getFileLocation(insuranceContract);
        if (!insuranceFileLocation) return null;

        let modalText = t(' Dlžník zároveň potvrdzuje, že sa oboznámil s informáciami o poistení schopnosti splácať pôžičku, prečítal si všetky potrebné dokumenty k poisteniu, ktoré sa nachádzajú na: ');
        let finalText = t('a súhlasí so Žiadosťou o zabezpečenie poistenia schopnosti splácať pôžičku.');
    
        modalText = (<span>{modalText} <a href={`${baseWeb}/na-stiahnutie`} target='blank'>majak.sk/na-stiahnutie</a> {finalText}</span>);
    
        let checkBoxText = t('Súhlasím so Žiadosťou o zabezpečenie poistenia')
        let buttonText = t('Potvrdiť Žiadosť o zabezpečenie poistenia')

        return (
            <SignBLock
                isLoading={isLoading}
                fileLocation={insuranceFileLocation}
                insuranceFileLocation={null}
                title={contractTypeT.INSURANCE_APPLICATION}
                text={modalText}
                checkboxText={checkBoxText}
                buttonText={buttonText}
                fileLinktext={t('Prečítať žiadosť')}
                onChecked={(val) => this.onChecked(contractType.INSURANCE_APPLICATION, val)}
                isChecked={this.state.signedContracts.INSURANCE_APPLICATION == true}
            />
        );
    }

    renderDeductionsAgreementContract(contract) {
        const { isLoading, t } = this.props;

        const fileLocation = this.getFileLocation(contract);
        if (!fileLocation) return null;

        let modalText = t('Dlžník sa oboznámil so znením Dohody o zrážkach, rozumie a súhlasí s jej znením a berie na vedomie všetky jej účinky a práva a povinnosti z nej vyplývajúce. Je si vedomý, že kliknutím na tlačidlo „Súhlasím s Dohodou o zrážkach“ je táto dohoda pre dlžníka v celom svojom rozsahu záväzná.');
    
        let checkBoxText = t('Súhlasím s Dohodou o zrážkach')
        let buttonText = t('Potvrdiť Dohodu o zrážkach')

        return (
            <SignBLock
                isLoading={isLoading}
                fileLocation={fileLocation}
                insuranceFileLocation={null}
                title={contractTypeT.DEDUCTIONS_AGREEMENT}
                text={modalText}
                checkboxText={checkBoxText}
                buttonText={buttonText}
                fileLinktext={t('Prečítať dohodu')}
                onChecked={(val) => this.onChecked(contractType.DEDUCTIONS_AGREEMENT, val)}
                isChecked={this.state.signedContracts.DEDUCTIONS_AGREEMENT == true}
            />
        );
    }

    renderGeneralContract(generalContract) {
        const { isLoading, t } = this.props;
        const fileLocation = this.getFileLocation(generalContract);
        if (!fileLocation) return null;

        return (
            <SignBLock
                isLoading={isLoading}
                fileLocation={fileLocation}
                title={contractTypeT.GENERAL}
                text={t(
                    'Dlžník sa oboznámil so znením Rámcovej zmluvy (zmluva medzi Vami a prevádzkovateľom portálu Majak.sk, spoločnosť Peer2Peer, s.r.o.), rozumie jej, súhlasí s jej znením a berie na vedomie všetky jej účinky ako aj všetky práva a povinnosti z nej vyplývajúce. Je si vedomý, že kliknutím na tlačidlo “Potvrdiť Rámcovú zmluvu” je táto zmluva pre dlžníka v celom svojom rozsahu záväzná.'
                )}
                checkboxText={t('Súhlasím s Rámcovou zmluvou')}
                buttonText={t('Potvrdiť Rámcovú zmluvu')}
                fileLinktext={t('Prečítať zmluvu')}
                onChecked={(val) => this.onChecked(contractType.GENERAL, val)}
                isChecked={this.state.signedContracts.GENERAL == true}
            />
        );
    }

    render() {
        const { unsignedContracts, pendingLoan } = this.props;
        const isPendingLoanSms = pendingLoan && pendingLoan.action === loanActions.ENTER_SMS_CODE_CONTRACT;
        const isPendingLoanSign = pendingLoan && pendingLoan.action === loanActions.SIGN_CONTRACT;
        const contractsToBesigned = unsignedContracts
            .filter(isApplicationSigningContract);

        if (contractsToBesigned.length === 0 && isPendingLoanSms) {
            return this.renderPendingSmsConfirmation();
        }

        if (contractsToBesigned.length === 0 && isPendingLoanSign) {
            return <SignLoanContractBlock loan={pendingLoan} />;
        }

        if (contractsToBesigned.length == 0 || (pendingLoan && pendingLoan.action === loanActions.UPLOAD_BANK_ACCOUNT_STATEMENTS)) {
            return null; 
        }

        const btnDisabled = contractsToBesigned.some(contract => !this.state.signedContracts[contract.type]);

        return (
            <div>
                {this.renderBlocks(unsignedContracts)}
                <Row>
                    <div className='ant-modal-footer'>
                        <Button
                            size="small"
                            type="primary"
                            loading={this.props.isLoading}
                            onClick={this.onSubmitAll}
                            disabled={btnDisabled}
                        >
                            { t('Potvrdiť všetky zmluvy')}
                        </Button>
                    </div>
                </Row>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/features/dashboard/components/registration-action-alert/SignContractDebtor.js